import { isLIFF, isTalaria } from './interface.utils';

export enum AppName {
  LINE = 'Line',
  UPAY = 'UPay',
  UNKNOWN = 'unknown',
}

export enum OS {
  ANDROID = 'Android',
  IOS = 'iOS',
  PC = 'pc', // could be others ?
}

const ua = typeof window !== 'undefined' ? window.navigator.userAgent : '';

export const getAppName = () => {
  const [, appName] = ua.match(/.*(Line|UPay)\//i) || [];

  switch (appName) {
    case AppName.LINE:
      return AppName.LINE;
    case AppName.UPAY:
      return AppName.UPAY;
    default:
      return AppName.UNKNOWN;
  }
};

export const getOS = () => {
  if (/android/i.test(ua)) {
    return OS.ANDROID;
  }

  if (
    /iPad|iPhone|iPod/i.test(ua) ||
    // for iPad iOS 13 or higher use the following way to check: https://stackoverflow.com/a/57924983
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  ) {
    return OS.IOS;
  }

  return OS.PC;
};

export const isLINE = () => {
  return /line\/\d/i.test(ua);
};

export const isUPay = () => {
  return /upay\/\d/i.test(ua);
};

export const isSafari = () => {
  return /Safari\/\d/i.test(ua);
};

export const isLIFFBrowser = () => {
  return /LIFF/i.test(ua);
};

export const isLINEIAB = () => {
  return isLINE() && !isLIFF() && !isTalaria();
};

export const isUPayIAB = () => {
  return isUPay();
};

export const isIAB = () => {
  return isLINEIAB() || isUPayIAB();
};

export const isEAB = () => {
  return !isLINE() && !isUPay() && getOS() !== OS.PC;
};

export const isWebBrowser = () => {
  return getOS() === OS.PC;
};

export const isAndroid = () => {
  return getOS() === OS.ANDROID;
};

export const isIOS = () => {
  return getOS() === OS.IOS;
};

export const getAppVersion = () => {
  const [, version] =
    ua.match(/.*(?:Line|Talaria|UPay|apppos-tw)\/([0-9+.]+)/i) || [];

  return version;
};

export const getOsVersion = () => {
  const [, version] =
    ua.match(/.*(?:Android|(?:iPhone|iPad).* OS) ([0-9_.]+)/i) || [];

  return version ? version.replace(/_/g, '.') : '';
};
